import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined"
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined"
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined"
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined"

export const NOTIFICATION_TYPES = {
  email: "emaileventtransaction",
  sms: "smseventtransaction",
  candidateImport: "candidateimportjob",
  uploadedLeadImport: "uploadedleadimportjob",
  inbox: "inboxthread",
  inboxSms: "inboxsmsthread",
  conciergeInboxTemplatePending: "conciergeinboxtemplatepending",
}

export const SUPPORTED_NOTIFICATION_TYPES = Object.values(NOTIFICATION_TYPES)

const TYPE_META = {
  [NOTIFICATION_TYPES.email]: {
    label: "Email",
    eventName: "email received",
    icon: EmailOutlinedIcon,
  },
  [NOTIFICATION_TYPES.sms]: {
    label: "SMS",
    eventName: "sms received",
    icon: SmsOutlinedIcon,
  },
  [NOTIFICATION_TYPES.candidateImport]: {
    label: "Candidate import",
    eventName: "Candidate import",
    icon: PersonAddOutlinedIcon,
  },
  [NOTIFICATION_TYPES.uploadedLeadImport]: {
    label: "Uploaded lead import",
    eventName: "Uploaded lead import",
    icon: CloudUploadOutlinedIcon,
  },
  [NOTIFICATION_TYPES.inbox]: {
    label: "Inbox email",
    eventName: "New email",
    icon: EmailOutlinedIcon,
  },
  [NOTIFICATION_TYPES.inboxSms]: {
    label: "Inbox SMS",
    eventName: "New SMS",
    icon: SmsOutlinedIcon,
  },
  [NOTIFICATION_TYPES.conciergeInboxTemplatePending]: {
    label: "Template approval",
    eventName: "Approval pending",
    icon: FactCheckOutlinedIcon,
  },
}

const UNKNOWN_TYPE_META = {
  label: "Notification",
  eventName: "Notification",
  icon: NotificationsOutlinedIcon,
}

export function isKnownNotificationType(type) {
  return SUPPORTED_NOTIFICATION_TYPES.includes(type)
}

export function getNotificationTypeMeta(type) {
  return TYPE_META[type] || UNKNOWN_TYPE_META
}

export function getNotificationTypeLabel(type) {
  return getNotificationTypeMeta(type).label
}

export function getNotificationTypeIcon(type) {
  return getNotificationTypeMeta(type).icon
}

export function getNotificationSortDate(notification) {
  return (
    notification?.completed_at ||
    notification?.date ||
    notification?.created ||
    null
  )
}

export function compareNotificationsByDateDesc(left, right) {
  const leftTime = new Date(getNotificationSortDate(left) || 0).getTime()
  const rightTime = new Date(getNotificationSortDate(right) || 0).getTime()
  return rightTime - leftTime
}

export function getNotificationItemKey(notification, index) {
  return `${notification?.type || "unknown"}-${notification?.id ?? index}`
}

export function normalizeNotificationsPayload(payload) {
  return Array.isArray(payload) ? payload : []
}

export function excludeNotificationsByTypeAndIds(notifications, type, ids) {
  const idSet = new Set(ids)
  return notifications.filter(
    (notification) =>
      !(notification.type === type && idSet.has(notification.id))
  )
}

export function getNotificationPreviewText(notification) {
  return (
    notification?.message ||
    notification?.subject ||
    notification?.text ||
    "You have a new notification."
  )
}

export function isInboxNotification(notification) {
  return (
    notification?.type === NOTIFICATION_TYPES.inbox ||
    notification?.type === NOTIFICATION_TYPES.inboxSms
  )
}

export function getInboxThreadReadUrl(notification) {
  if (!notification?.id) {
    return null
  }
  if (notification.type === NOTIFICATION_TYPES.inboxSms) {
    return `/crm/api/concierge-sms/inbox/threads/${notification.id}/read/`
  }
  if (notification.type === NOTIFICATION_TYPES.inbox) {
    return `/crm/api/zoho-mail/inbox/threads/${notification.id}/read/`
  }
  return null
}
